import { toast } from 'react-toastify'
import { ErrorTypeEnum, Message } from '../../../_services/ResponseErrorType'
import { RaytebRequests } from '../../../_services'
import useFetch from '../../../_services/fetch'
import { useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { useDispatch, useSelector } from 'react-redux'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import { addOrUpdatePrescription } from '../../../storeManager/Reducers/prescriptionSlice'
import { Button, Icon, RaytebForm, Select, TextBox } from '../../Elements'
import LoadingFit from '../Loading/LoadingFit'
import RaytebModal from './RaytebModal'
import { GenderEnum } from '../../../enums/GenderEnum'
import Avatar from '../ImageAvatars/Avatar'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { DeserveDataModalInterface } from '../../../Interfaces/DeserveModalInterface'
import React from 'react'
import { GetForUnRegisterUserInderface } from '../../../Interfaces/GetForUnRegisterUserInderface'

const GetForUnRegisterUserModal: React.FC<GetForUnRegisterUserInderface> = ({
  isOpen,
  showFooter,
  data,
  doctorServeShift,
  ticketId,
  hideModal,
  onAdded,
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const dispatch = useDispatch()

  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )

  const { isLoading, reFetch } = useFetch<PrescriptionViewModel, Object>({
    request: RaytebRequests.Prescription_GetForUnRegisterUser_GET(
      user?.token!,
      { centerId: center.id }
    ),
    onSuccess(res) {
      dispatch(addOrUpdatePrescription(res))
      onAdded?.(res, doctorServeShift)
    },
  })

  const [isEditMobile, setEditMobile] = useState<boolean>(false)
  const changeMobile = useFetch<Array<Message>, ChnageMobileInputModel>({
    request: RaytebRequests.Patient_ChnageMobile_POST({
      centerId: center.id,
      token: user?.token,
    }),
    onSuccess(data) {
      data.forEach((n) => {
        if (n.flag === ErrorTypeEnum.Error) toast.error(n.message)
        else if (n.flag === ErrorTypeEnum.Info) toast.info(n.message)
        else if (n.flag === ErrorTypeEnum.Warning) toast.warn(n.message)
        else toast.info(n.message)
      })
      setEditMobile(false)
    },
  })
  function instanceOf(object: any): object is DeserveDataModalInterface {
    return object && 'imageUrl' in object
  }
  return (
    <RaytebModal
      isOpen={isOpen}
      hideModal={() => hideModal?.()}
      title='ویرایش اطلاعات بیمار'
      className={
        '!shadow-inner xs:min-w-[96%] relative max-h-screen overflow-y-auto'
      }
    >
      <LoadingFit isLoading={changeMobile.isLoading || isLoading} />
      {instanceOf(data?.data.data) ? (
        <div className='w-full max-w-sm  rounded-lg px-2 '>
          <div className='flex flex-col items-center '>
            <Avatar
              className='!w-24 !h-24 !text-4xl !mb-3 !rounded-full !p-1 !shadow-inner !shadow-disable'
              url={data?.data.data.imageUrl}
            />
            <h5 className='mb-1 text-sm font-extrabold '>{`${data?.data.data.firstName} ${data?.data.data.lastName}`}</h5>

            <div className='grid grid-cols-3   mt-10 w-full gap-x-2 gap-y-6 '>
              {data?.data.data.insuranceTypeTitle ? (
                <DetailInfo
                  title={'بیمه'}
                  value={data?.data.data.insuranceTypeTitle}
                />
              ) : (
                ''
              )}
              {data?.data.data.mobile ? (
                <RaytebForm
                  checkIsRequired={true}
                  onSubmit={(e) => {
                    changeMobile.reFetch({
                      patientCode: (
                        data?.data.data as DeserveDataModalInterface
                      ).code!,
                      phoneNumber: e.target['Mobile'].value,
                    })
                  }}
                >
                  <DetailInfo
                    title={'موبایل'}
                    value={data?.data.data.mobile}
                    isEdit={true}
                    onShow={() => setEditMobile(true)}
                    onClose={() => setEditMobile(false)}
                    isOpen={isEditMobile}
                    editOption={{
                      innerText: 'تغییر شماره همراه',
                      Type: TextBoxTypeEnum.Mobile,
                      isLtR: false,
                      isRequired: true,
                      name: 'Mobile',
                      onClick: (e) => {
                        e.target.select()
                      },
                    }}
                  />
                </RaytebForm>
              ) : (
                ''
              )}
              {data?.data.data.age ? (
                <DetailInfo title={'سن'} value={data?.data.data.age} />
              ) : (
                ''
              )}
              {data?.data.data.insuranceExpirationDate ? (
                <DetailInfo
                  title={'تاریخ انقضا'}
                  value={data?.data.data.insuranceExpirationDate}
                />
              ) : (
                ''
              )}
              {data?.data.data.gender ? (
                <DetailInfo
                  title={'جنسیت'}
                  value={GenderEnum[data?.data.data.gender]}
                />
              ) : (
                ''
              )}
            </div>
            {data?.data.data.servePrice?.insureShare != null &&
              data?.data.data.servePrice?.patientShare != null &&
              data?.data.data.servePrice?.patientShare != null ? (
              <div className='grid grid-cols-3  items-center mt-4 w-full gap-x-4 gap-y-6  py-3'>
                {data?.data.data.servePrice?.insureShare != null ? (
                  <DetailInfo
                    className='!border-warnDark'
                    title={'سهم سازمان'}
                    value={data?.data.data.servePrice?.insureShare}
                  />
                ) : (
                  ''
                )}
                {data?.data.data.servePrice?.patientShare != null ? (
                  <DetailInfo
                    className='!border-warnDark'
                    title={'سهم بیمار'}
                    value={data?.data.data.servePrice?.patientShare}
                  />
                ) : (
                  ''
                )}
                {data?.data.data.servePrice?.total != null ? (
                  <DetailInfo
                    className='!border-warnDark'
                    title={'کل'}
                    value={data?.data.data.servePrice?.total}
                  />
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}

            <div className='mt-4'>
              {data?.data.data.servePrice?.messages?.map((n, i) => (
                <div key={i}>
                  {n.flag === ErrorTypeEnum.Error ? (
                    <span className='text-danger text-[11px]'>{n.message}</span>
                  ) : n.flag === ErrorTypeEnum.Warning ? (
                    <span className='text-warn text-[11px]'>{n.message}</span>
                  ) : n.flag === ErrorTypeEnum.Info ? (
                    <span className='text-warn text-[11px]'>{n.message}</span>
                  ) : (
                    n.message
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className='py-5'>
            <p
              style={{ lineHeight: '19px' }}
              className='text-xs text-primary font-bold 
             underline underline-offset-4 decoration-dotted decoration-amber-500'
            >
              پزشک محترم، اطلاعات بیمار با شناسه  توسط سرویس های استحقاق یافت نشد
              لطفا نام و نام خانوادگی بیمار را وارد نمایید
            </p>
            {/* {data?.messages?.map((n, i) => (
              <p key={i} className='flex justify-start items-center'>
                {n.flag === ErrorTypeEnum.Error ? (
                  <span className='text-danger text-[11px]'>{n.message}</span>
                ) : n.flag === ErrorTypeEnum.Warning ? (
                  <span className='text-warn text-[11px]'>{n.message}</span>
                ) : n.flag === ErrorTypeEnum.Info ? (
                  <span className='text-warn text-[11px]'>{n.message}</span>
                ) : (
                  n.message
                )}
              </p>
            ))} */}
          </div>
          <RaytebForm
            checkIsRequired={true}
            onSubmit={(e) => {
              reFetch({
                patientCode: (data?.data.data as DeserveDataModalInterface)
                  .code!,
                doctorServeShift: doctorServeShift,
                firstName: e.target['firstName'].value,
                lastName: e.target['lastName'].value,
                ticketId: ticketId
              })
            }}
          >
            <div className=' px-16 pb-3  grid grid-cols-1 gap-5'>
              <TextBox
                innerText='نام'
                Type={TextBoxTypeEnum.Text}
                name='firstName'
                isRequired={true}
              />
              <TextBox
                isRequired={true}
                innerText='نام خانوادگی'
                Type={TextBoxTypeEnum.Text}
                name='lastName'
              />
            </div>

            <div className='flex justify-center items-center px-6 gap-10 w-full py-3 sticky top-full'>
              <Button
                onClick={() => hideModal?.()}
                className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
              >
                انصراف
              </Button>
              <Button
                className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
                type='submit'
              >
                ثبت نسخه
              </Button>
            </div>
          </RaytebForm>
        </div>
      ) : (
        <RaytebForm
          className='p-2'
          onSubmit={(e) => {
            reFetch({
              patientCode: data?.data.data.code!,
              doctorServeShift: doctorServeShift,
              firstName: e.target['firstName'].value,
              lastName: e.target['lastName'].value,
              mobile: data?.data.data.mobile,
              codeTypeId: e.target['codeTypeId'].value,
              ticketId: ticketId
            })
          }}
          checkIsRequired={true}
        >
          <p
            style={{ lineHeight: '19px' }}
            className='text-xs text-primary font-bold 
             underline underline-offset-4 decoration-dotted decoration-amber-500'
          >
            پزشک محترم، اطلاعات بیمار مورد نظر توسط سرویس های استحقاق یافت نشد
            لطفا اطلاعات مورد نظر را وارد نمایید
          </p>
          <div className='grid grid-cols-1 px-12 py-4 gap-4'>
            <Select
              isRequired={true}
              name='codeTypeId'
              msgValidate='انتخاب نوع کد نمیتواند خالی باشد'
            >
              <option value={''}>انتخاب نوع کد</option>
              <option value={'2'}>شماره کارت سبز</option>
              <option value={'3'}>شماره گذرنامه</option>
            </Select>
            <TextBox
              isRequired={true}
              Type={TextBoxTypeEnum.Text}
              name='firstName'
              innerText='نام'
            />
            <TextBox
              isRequired={true}
              Type={TextBoxTypeEnum.Text}
              name='lastName'
              innerText='نام خانوادگی'
            />
          </div>
          <div className='flex justify-center items-center px-6 gap-10 w-full py-3 sticky top-full'>
            <Button
              onClick={() => hideModal?.()}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
              type='submit'
            >
              ثبت نسخه
            </Button>
          </div>
        </RaytebForm>
      )}
    </RaytebModal>
  )
}
const DetailInfo = ({
  title,
  value,
  className,
  isEdit,
  editOption,
  isOpen,
  onClose,
  onShow,
}: {
  title: string
  value: any
  className?: string
  isEdit?: boolean
  editOption?: TextBoxInterface
  isOpen?: boolean
  onClose?: () => void
  onShow?: () => void
}) => {
  return (
    <>
      <div
        className={`border-x-2 border-primary border-dashed  rounded-md 
                px-4 py-2 flex flex-col justify-center
               items-center relative ${className ?? ''}`}
        style={{ direction: 'initial' }}
      >
        {isOpen ? (
          <>
            <div
              className='absolute -top-36 flex justify-center  items-center flex-col z-[96]
           bg-primaryDefault2'
            >
              <div className='px-2 my-5'>
                <TextBox {...editOption!} />
              </div>
              <div className='flex justify-center items-center px-6 gap-10 w-full py-3 sticky top-full'>
                <Button
                  type='submit'
                  className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-6 !shadow-lg'
                >
                  <Icon icon='rayteb-android-done' />
                </Button>
                <Button
                  onClick={() => onClose?.()}
                  className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-6 !shadow-lg'
                >
                  <Icon icon='rayteb-android-close' />
                </Button>
              </div>
            </div>
            <Icon
              icon='rayteb-arrow-down-b'
              className='absolute -top-9 bottom-0 text-3xl animate-ping h-10 w-10 text-warnDark'
            />
          </>
        ) : (
          ''
        )}
        <span className='absolute -top-3 text-xs text-primary'>{title}</span>
        <span
          onClick={() => onShow?.()}
          className={`text-center text-xs ${isEdit
            ? 'underline decoration-primary decoration-dashed underline-offset-8'
            : ''
            }`}
        >
          {value}
        </span>
      </div>
    </>
  )
}
export default React.memo(GetForUnRegisterUserModal)
